<template>
  <b-modal :active.sync="isModalActive" has-modal-card :can-cancel="true">
    <div class="modal-card">
      <header class="modal-card-head">
        <h1 class="is-title-header modal-card-title">View Rule Syntax</h1>
      </header>
      <section class="modal-card-body overflow-scroll">
        <div class="columns">
          <div class="column">
            {{ formData.condition_sql }}
          </div>
        </div>
      </section>
      <footer class="modal-card-foot">
        <b-button slot="right" class="is-normal" @click="cancel">
          Cancel
        </b-button>
      </footer>
    </div>
  </b-modal>
</template>

<script>
import UtilityMixin from "@/mixins/UtilityMixin";
import scopeMixin from "@/mixins/scopeMixin";
// @group Dashboard
export default {
  name: "ViewSyntex",
  mixins: [UtilityMixin, scopeMixin],
  props: {
    isActive: {
      type: Boolean,
      default: false
    },
    rules: {
      type: Object
    },
    formData: {
      type: Object
    }
  },

  data() {
    return {
      isModalActive: false
    };
  },
  methods: {
    cancel() {
      this.$emit("cancel");
    }
  },
  watch: {
    isActive(newValue) {
      this.isModalActive = newValue;
    },
    isModalActive(newValue) {
      if (!newValue) {
        this.cancel();
      }
    }
  }
};
</script>
